import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import PhoneIcon from '@mui/icons-material/Phone';

const ContactPage = () => {
    return (
        <Box
            sx={{
                backgroundImage: 'linear-gradient(to bottom, #120222, #095c79)',
                minHeight: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: 4
            }}
        >
            <Stack spacing={4} sx={{ maxWidth: 600, textAlign: 'center', color: 'white' }}>
                <Typography variant="h3" sx={{ fontWeight: 'bold' }}>
                    Contact Me
                </Typography>
                <Typography variant="h6" sx={{ color: '#B0BEC5' }}>
                    I'd love to connect! Here’s how you can reach me:
                </Typography>

                {/* Email */}
                <a href="mailto:hjmsoc@gmail.com" style={{ textDecoration: 'none', color: 'inherit' }}>
                    <Stack direction="row" spacing={2} alignItems="center" justifyContent="center">
                        <IconButton color="inherit">
                            <MailOutlineIcon />
                        </IconButton>
                        <Typography variant="body1">hjmsoc@gmail.com</Typography>
                    </Stack>
                </a>

                {/* Phone */}
                <a href="tel:+6586869263" style={{ textDecoration: 'none', color: 'inherit' }}>
                    <Stack direction="row" spacing={2} alignItems="center" justifyContent="center">
                        <IconButton color="inherit">
                            <PhoneIcon />
                        </IconButton>
                        <Typography variant="body1">+65 8686 9263</Typography>
                    </Stack>
                </a>

                {/* LinkedIn */}
                <a href="https://www.linkedin.com/in/hengjiaming" target="_blank" style={{ textDecoration: 'none', color: 'inherit' }} rel="noreferrer">
                    <Stack direction="row" spacing={2} alignItems="center" justifyContent="center">
                        <IconButton color="inherit">
                            <LinkedInIcon />
                        </IconButton>
                        <Typography variant="body1">LinkedIn Profile</Typography>
                    </Stack>
                </a>

                {/* GitHub */}
                <a href="https://github.com/hengjiaming" target="_blank" style={{ textDecoration: 'none', color: 'inherit' }} rel="noreferrer">
                    <Stack direction="row" spacing={2} alignItems="center" justifyContent="center">
                        <IconButton color="inherit">
                            <GitHubIcon />
                        </IconButton>
                        <Typography variant="body1">GitHub Profile</Typography>
                    </Stack>
                </a>

                {/* Direct Email Button */}
                <Button
                    variant="contained"
                    href="mailto:hjmsoc@gmail.com"
                    sx={{
                        backgroundColor: '#1E88E5',
                        color: 'white',
                        fontWeight: 'bold',
                        textTransform: 'none',
                        borderRadius: 2,
                        paddingY: 1.5,
                        '&:hover': { backgroundColor: '#1565C0' },
                    }}
                >
                    Email Me
                </Button>
            </Stack>
        </Box>
    );
};

export default ContactPage;